if (!customElements.get("page-spokesperson")) {
  customElements.define(
    "page-spokesperson",
    class PageSpokesperson extends HTMLElement {
      constructor() {
        super();
      }

      init() {
        this.swiper_1 = new Swiper(this.querySelector(".ps-section3 .swiper"), {
          slidesPerView: 1.5,
          spaceBetween: 20,
          breakpoints: {
            768: {
              slidesPerView: 4,
            },
          },
        });
        this.swiper_2 = new Swiper(this.querySelector(".ps-section5 .swiper"), {
          slidesPerView: 1,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        });
      }

      initVideoFullScreenPlay() {
        const triggerElement = this.querySelectorAll(".play-video-full");
        triggerElement.forEach((item) => {
          item.addEventListener("click", () => {
            const videoUrl = item.getAttribute("data-url");
            const video = document.createElement("video");
            video.src = videoUrl;
            video.controls = true;
            video.muted = true;
            video.setAttribute("controls", "");
            video.setAttribute("loop", "");
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            video.classList.add("full-video");
            const maskDom = document.createElement("div");
            maskDom.classList.add("full-video-mask", "animate__animated", "animate__fadeIn");
            document.body.appendChild(maskDom);
            document.body.appendChild(video);
            video.play();
            maskDom.addEventListener("click", () => {
              video.pause();
              document.body.removeChild(video);
              document.body.removeChild(maskDom);
            });
          });
        });
      }

      initMobileVideoPlayer() {
        const videoIcon = this.querySelector(".ps-section4-video-icon");
        videoIcon.addEventListener("click", () => {
          const videoWrap = this.querySelector(".ps-section4-video");
          const video = videoWrap.querySelector("video");
          videoWrap.classList.toggle("active");
          video.play();
          videoIcon.classList.toggle("active");
        });
      }

      connectedCallback() {
        this.init();
        this.initVideoFullScreenPlay();
        this.initMobileVideoPlayer();
      }
    }
  );
}
